import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { RAIL_REVIEW_PATH } from '../../constants/URLconstants';

class PaymentTimeOut extends Component {
  componentWillMount() {
    const selectedTrainInfo = JSON.parse(localStorage.getItem('selectedTrainInfo'));
    this.props.history.push(RAIL_REVIEW_PATH, selectedTrainInfo);
  }

  render() {
    return <div/>;
  }
}

export default withRouter(PaymentTimeOut);
